"use client"

import { usePathname, useRouter } from "next/navigation"
import { SearchButton } from "../../component/SearchButton/SearchButton"

interface HeroSearchButtonProps {
  label?: string
  searchFilter?: string
  searchIndex?: string
}

export function HeroSearchButton({
  label,
  searchFilter,
  searchIndex,
}: HeroSearchButtonProps) {
  const router = useRouter()
  const pathname = usePathname()

  const onSearch = (value: string) => {
    const params = new URLSearchParams(window.location.search)
    params.set("search", value)
    if (searchFilter) params.set("searchFilter", searchFilter)
    if (searchIndex) params.set("searchIndex", searchIndex)
    router?.push(`${pathname}?${params.toString()}`)
  }

  return <SearchButton label={label} onSearch={onSearch} />
}
